import constants from './constants';
import { getScript } from '@/modules/functions';

export class ApiHandler {
    constructor() {
    }

    load(callback) {
        if (window.google && window.google.maps) {
            callback();
            return;
        }
        getScript(constants.urlApi, () => {
            for(var lib in constants.mapOptions.libs){
                getScript(constants.mapOptions.libs[lib]);
            }
            callback()
        });
    }
}